<template>
	<div class="centerWidth">
		<div class="gaokao-nav">
			<span @click="goMyCenter">个人中心 ></span>
			<span>一键志愿填报</span>
		</div>
		<section class="gaokao-content">
			<ul class="gkTest-step">
				<li>
					<div class="step-con step-on flex zhong center">
						<div>
							<p>1</p>
							<span>信息校对</span>
						</div>
					</div>
				</li>
				<li>
					<div class="step-con flex zhong center"><img src="../../../image/Eva-arr-aa.png" /></div>
				</li>
				<li>
					<div class="step-con step-on flex zhong center">
						<div>
							<p>2</p>
							<span>选择填报批次</span>
						</div>
					</div>
				</li>
				<li>
					<div class="step-con flex zhong center"><img src="../../../image/Eva-arr-aa.png" /></div>
				</li>
				<li>
					<div class="step-con flex zhong center">
						<div>
							<p>3</p>
							<span>填写志愿表</span>
						</div>
					</div>
				</li>
				<li>
					<div class="step-con flex zhong center"><img src="../../../image/Eva-arr-a.png" /></div>
				</li>
				<li>
					<div class="step-con flex zhong center">
						<div>
							<p>4</p>
							<span>生成志愿表</span>
						</div>
					</div>
				</li>
			</ul>
			<p class="test-tit">选择填报批次</p>
			<article class="enroll-table">
				<table class="enroll-table-con" cellpadding="0" cellspacing="0" align="center" rules="none">
					<tr>
						<th>报考批次</th>
						<th>{{ yers }}年省控线</th>
						<th>操作</th>
					</tr>
					<tr>
						<td>本科批</td>
						<td>{{ score }}</td>
						<td><span @click="goNextc">开始</span></td>
					</tr>
				</table>
			</article>
			<div class="gaokao-notice">
				<p class="gk-notice-tit">重要提示</p>
				<ul class="gk-notice-li">
					<li>1、本系统仅用于模拟高考志愿填报，不等同于实际的网上填报志愿;</li>
					<li>2、本系统依据高校历年录取数据进行推荐，仅用于志愿填报参考，平台不对实际录取结果做保证，建议考生在实际填报前，进一步咨询目标高校;</li>
					<li>3、本系统公布的专业招生计划可能会有变动，正式填报时请以该省教育考试院公布的为准;</li>
					<li>4、实际填报时，请务必对照省教育考试院本年度最新招生计划确认目标院校招生专业和代码。</li>
				</ul>
			</div>
		</section>
	</div>
</template>

<script>
import Cookies from 'js-cookie';
export default {
	data() {
		return {
			sel: '',
			score: '',
			yers: '',
			condition: {},
			IsCke: true
		};
	},
	// 加载
	created() {
		var that = this;
		var condition = Cookies.get('TBZYcondition');
		if (condition !== undefined) {
			that.condition = JSON.parse(condition);
			that.$api.HtppRequest(
				'SystemData/GetProvincialControlLineScore?cityCode=' + that.condition.cityCode + '&candidatesType=' + that.condition.subject,
				'GET',
				{},
				function(res) {
					console.log('获取', res);
					if (res.flag) {
						that.score = res.score;
						that.yers = res.yers;
						if (that.score === '') {
							that.IsCke = false;
						} else {
							that.IsCke = true;
						}
					} else {
						that.IsCke = false;
					}
				},
				function(err) {
					console.log(err);
				}
			);
		}
	},

	methods: {
		// 个人中心
		goMyCenter() {
			this.$router.push('/myIndex');
		},
		// 填报志愿
		goNextc() {
			this.$router.push('/volunteerc');
		}
	}
};
</script>

<style scoped>
.gaokao-nav {
	width: 100%;
	display: flex;
	align-items: center;
	padding: 20px 0;
}
.gaokao-nav span {
	font-size: 15px;
	color: #333;
}
.gaokao-nav span:last-child {
	color: #333;
}
/* gaokao-content */
.gaokao-content {
	padding: 0 20px;
	width: 100%;
	height: auto;
	overflow: hidden;
	background-color: #fff;
	margin-bottom: 25px;
}

.test-tit {
	font-size: 16px;
	color: #333;
	position: relative;
	padding-left: 20px;
	margin-bottom: 30px;
}
.test-tit::after {
	position: absolute;
	content: '';
	width: 0;
	height: 20px;
	left: 0;
	top: 50%;
	margin-top: -10px;
	border: 2px solid #333;
	border-radius: 50px;
}
/* enroll-table */
.enroll-table {
	width: 100%;
	height: auto;
	overflow: hidden;
	margin-bottom: 40px;
}
.enroll-table-con {
	width: 100%;
	height: auto;
	overflow: hidden;
	border: 1px solid #eee;
}
.enroll-table-con tr {
	border-bottom: 1px solid #eee;
}
.enroll-table-con tr th {
	font-size: 15px;
	color: #333;
	height: 60px;
	line-height: 60px;
	background-color: #eaeaea;
	width: calc(100% / 3);
}
.enroll-table-con tr td {
	border-right: 1px solid #eee;
	font-size: 15px;
	color: #333;
	text-align: center;
	height: 58px;
	width: calc(100% / 3);
}
.enroll-table-con tr td span {
	width: 80px;
	height: 30px;
	line-height: 28px;
	border: 1px solid #333;
	font-size: 15px;
	color: #333;
	cursor: pointer;
	text-align: center;
	display: block;
	margin: 0 auto;
	border-radius: 5px;
}

/* gaokao-notice */
.gaokao-notice {
	width: 100%;
	padding: 0 40px 40px 40px;
	height: auto;
	overflow: hidden;
	background-color: #eee;
	margin-bottom: 30px;
}
.gk-notice-tit {
	font-size: 17px;
	color: #fa3d32;
	padding: 25px 0;
}
.gk-notice-li {
	width: 100%;
	height: auto;
	overflow: hidden;
}
.gk-notice-li li {
	font-size: 15px;
	color: #333;
	padding-bottom: 15px;
}
.gk-notice-li li:last-child {
	padding-bottom: 0px;
}
.gkTest-step {
	padding: 40px;
}
</style>
